import { Component,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChildren, QueryList, inject, DestroyRef ,
  ChangeDetectionStrategy,
} from '@angular/core';
import { SplAllocService } from '../../services/spl-alloc.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { cloneDeep } from 'lodash-es';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  extractObject,
  generalConfigFromGlobal,
  hydratedGlobalParams,
  normalizeFilterParams,
  rowPayloadFromActiveScreen,
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-pship-spl-alloc',
    templateUrl: './spl-alloc.component.html',
    styleUrls: ['./spl-alloc.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SplAllocComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();

  GENERAL_CONFIG: any = {};
  globalParams: any = {};
  filterParams: any = {};
  rowData: any = {};

  private baseURL = '/gtw';
  private checkLockedObj: any = [];
  private taxYear: number = 0;
  private scenario: number = 0;
  private jcdKey: number = 0;
  private ssoId: string = '';
  private combinationKey: number = 0;
  private processName: string = '';
  private scenarioCode: string = '';
  private isIssueKeyEnabled: string = '';
  private isLocked: string = '';
  private issueKey: number = 0;

  minimise = false;
  modalTitle = '';

  clob_settings: any = {};
  clob_data: any = [];
  rowsEdited: any = [];

  public validationErrMsg: string = '';

  @ViewChildren('ratioOverrides') ratioOverrides!: QueryList<any>;
  @ViewChildren('amountOverrides') amountOverrides!: QueryList<any>;

  isLoading = false;
  isSaving = false;

  splAllocPopupData: any = [];
  ptrRatioData: any = [];
  firstRow: any = [];
  headers: any = [];
  ptrHeaders: any = [];
  partnerRatioHeaders: any = [];

  ptrRatioJson: any = {};
  ptrRatioArray: any = [];
  firstTableConfig: any = { pagination: false };
  detailsTableConfig: any = { pagination: false };

  constructor(
    private splAllocService: SplAllocService,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
  ) {
    this.processName = 'Save Partnership Special Allocation';
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.init();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.init();
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    this.GENERAL_CONFIG = generalConfigFromGlobal(this.gtwGlobal);
    this.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
    this.filterParams = normalizeFilterParams(activeScreen);
    const rawRow = rowPayloadFromActiveScreen(activeScreen);
    this.rowData = Array.isArray(rawRow) ? extractObject(rawRow[0]) : extractObject(rawRow);

    this.baseURL = this.GENERAL_CONFIG?.base_url || '/gtw';
    this.taxYear = Number(this.globalParams?.tax_year || this.filterParams?.tax_year || 0);
    this.scenario = Number(this.globalParams?.scenario || this.filterParams?.scenario || 0);
    this.jcdKey = Number(this.globalParams?.jcd_key || this.filterParams?.jcd_key || 250);
    this.ssoId = this.globalParams?.sso_id || '';
    this.combinationKey = Number(this.rowData?.COMBINATION_KEY || this.filterParams?.combination_key || 0);
    this.scenarioCode = this.globalParams?.scenario_type_code || this.filterParams?.scenario_code || '';
    this.isIssueKeyEnabled = this.globalParams?.is_issue_key_enabled || 'N';
    this.issueKey = Number(this.globalParams?.issue_key || this.filterParams?.issue_key || 0);
    this.isLocked = this.rowData?.IS_LOCKED || 'N';
    this.isSaving = this.isLocked === 'Y';

    this.checkLockedObj = this.rowData?.LEID ? [{
      leid: this.rowData.LEID,
      cdr_number: this.rowData.CDR_NO,
      reporting_period: this.rowData.REPORTING_PERIOD,
      combination_key: this.combinationKey,
      scenario_key: this.scenario,
    }] : [];

    const scenarioLabel = this.globalParams?.scenario_desc || 'Return As Filed';
    this.modalTitle = `Edit Special Allocation (Tax Year : ${this.taxYear} - Scenario : ${scenarioLabel})`;

    this.cdr.markForCheck();
  }

  init() {
    try {
      if (!this.taxYear || !this.scenario || !this.combinationKey) return;
      this.getSplAllocPopupData();
    } catch (e) {
      console.error('Error in SplAlloc init:', e);
    }
  }

  getSplAllocPopupData() {
    console.log('Get Spl Alloc Popup Data Called.');
    if(this.splAllocPopupData.length == 0 && !this.isLoading) {

      this.isLoading = true;

      this.splAllocService.getSplAllocPopupData(this.baseURL, this.taxYear, this.scenario, this.jcdKey, this.combinationKey, this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any[]) => {
        let index;
        let headerObj = {key:'', value:''};
        let headerObjCloned = {key:'', value:''};

        let ptrHeaderObj = {key:'', value:''};
        let ptrHeaderObjCloned = {key:'', value:''};

        if (data) {
            this.isLoading = false;
            this.splAllocPopupData = data;
            console.log('splAllocPopupData = ', this.splAllocPopupData);

            this.firstRow.push(this.splAllocPopupData[0]);
            console.log('firstRow = ', this.firstRow);

            for(let key in this.firstRow[0]) {
              index = Object.keys(this.firstRow[0]).indexOf(key);
              console.log('index = ', index);
              if(index > 16) {
                if(key !== 'COMBINATION_KEY' && key !== 'ACCT_KEY' && key !== 'DISPLAY_ORDER' && key !== 'TRADING_PTR') {
                  headerObjCloned = cloneDeep(headerObj);
                  headerObjCloned.key = key;
                  if(key === 'ACCT')
                    headerObjCloned.value = 'Account No.';
                  else if(key === 'ACCT_DESC')
                    headerObjCloned.value = 'Account Description';
                  else if(key === 'TRADING_PARTNER')
                    headerObjCloned.value = 'Trading Partner';
                  else if(key === 'ISSUE_KEY')
                    headerObjCloned.value = 'Issue ID';
                  else if(key === 'PSHIP_AMT')
                    headerObjCloned.value = 'Partnership Amount';
                  else if(key === 'PSHIP_AMT_USD')
                    headerObjCloned.value = 'Partnership Amount (USD)';
                  else if(key === 'VARIANCE')
                    headerObjCloned.value = 'Variance';
                  else if(key === 'OVERRIDE_TYPE')
                    headerObjCloned.value = 'Override Type';
                  else if(key === 'TOTAL_ALLOCATION')
                    headerObjCloned.value = 'Total Allocation';
                  else if(key.includes('/')){
                    ptrHeaderObjCloned = cloneDeep(ptrHeaderObj);
                    ptrHeaderObjCloned.key = key;
                    ptrHeaderObjCloned.value = key;
                  }

                  if(key.includes('/'))
                    this.ptrHeaders.push(ptrHeaderObjCloned);
                   else
                    this.headers.push(headerObjCloned);
                }
              }
            }
            console.log('headers = ', this.headers);
            console.log('ptrHeaders = ', this.ptrHeaders);

            this.getPtrRatio();

           }
        },
        error => {
          this.isLoading = false;
          console.log(error);
        }, () => {
          this.isLoading = false;
          console.log('Completed all tabs');
        }

      );
    }

  }

  getPtrRatio() {

    console.log('Get getPtrRatio () Called.');

    if(this.ptrRatioData.length == 0) {
        this.splAllocService.getPtrRatio(this.baseURL, this.taxYear, this.scenario, this.jcdKey, this.combinationKey, this.ssoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe ((data: any[]) => {
          if (data) {
            this.ptrRatioData = data;

            console.log('ptrRatioData = ', this.ptrRatioData);

            this.ptrRatioJson = this.ptrRatioData[0];
            console.log('ptrRatioJson = ', this.ptrRatioJson);

            for(let key in this.ptrRatioData[0]) {
              if(key.includes('/')) {
                this.partnerRatioHeaders.push(key);
                this.ptrRatioArray.push(this.ptrRatioJson[key]);
              }
            }
            console.log('ptrRatioArray = ', this.ptrRatioArray);
            console.log('partnerRatioHeaders = ', this.partnerRatioHeaders);
          }

        },
        error => {
          this.isLoading = false;
          console.log(error);
        }, () => {
          this.isLoading = false;
          console.log('Completed all tabs');
        }

      );
    }

  }

  keyPressNumbers(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9 and minus
    if(charCode == 45 || charCode == 45 || charCode == 48 || charCode == 49 || charCode == 50 || charCode == 51 || charCode == 52 || charCode == 53 || charCode == 54 || charCode == 55 || charCode == 56 || charCode == 57) {
      return true;
    }
    else {
      event.preventDefault();
      return false;
    }

  }

  keyPressDecimal(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9 , minus and dot
    if(charCode == 45 || charCode == 46 || charCode == 45 || charCode == 48 || charCode == 49 || charCode == 50 || charCode == 51 || charCode == 52 || charCode == 53 || charCode == 54 || charCode == 55 || charCode == 56 || charCode == 57) {
      return true;
    }
    else {
      event.preventDefault();
      return false;
    }

  }

  setOverrideOption(overrideOption: any, index: any) {
    if (this.splAllocPopupData && this.splAllocPopupData[index]) {
      this.splAllocPopupData[index].OVERRIDE_TYPE = (overrideOption === 'amount') ? 1 : 0;
    }

    const enableRatio = overrideOption === 'ratio';

    this.ratioOverrides.forEach((el: any) => {
      const id = el.nativeElement ? el.nativeElement.id : (el.id || '');
      if (id.startsWith('ratio-override-' + index)) {
        const nativeEl = el.nativeElement || el;
        nativeEl.disabled = !enableRatio;
      }
    });

    this.amountOverrides.forEach((el: any) => {
      const id = el.nativeElement ? el.nativeElement.id : (el.id || '');
      if (id.startsWith('amount-override-' + index)) {
        const nativeEl = el.nativeElement || el;
        nativeEl.disabled = enableRatio;
      }
    });
  }

  calcVariance(event: any, rowIndex: number, keyCol: any, overrideType: any) {

    let defaultAlloc;
    let splAllocAmt;
    let splAllocAmtOrg;
    let splAllocRatio;
    let splAllocRatioOrg;
    let totalAllocCalc = 0;
    let currRow = this.splAllocPopupData[rowIndex];
    let totalAllocation = currRow.TOTAL_ALLOCATION;
    let pshipAmt = currRow.PSHIP_AMT;
    let updatedPartnerAmts;
    let calcAmt;

    if (event.value.length === 1) {
      if(event.value == '-') return;
    }
    else if(event.value.length > 1) {
      if((event.value.match(/-/g) || []).length > 1) return;
    }

    currRow.IS_DIRTY = 'Y';

    for(let key in currRow) {

      if(key.includes('/') ) {
        console.log('--- key = ', key);

        defaultAlloc = currRow[key].split(',')[0];
        console.log('defaultAlloc = ', defaultAlloc);

        splAllocAmtOrg = currRow[key].split(',')[1];
        console.log('splAllocAmtOrg = ', splAllocAmtOrg);

        //splAllocAmt = currRow[key].split(',')[1];
        //console.log('splAllocAmt = ', splAllocAmt);

        splAllocRatioOrg = currRow[key].split(',')[2];
        console.log('splAllocRatioOrg = ', splAllocRatioOrg);

        //splAllocRatio = currRow[key].split(',')[2];
        //console.log('splAllocRatio = ', splAllocRatio);

        /*if(splAllocRatio === undefined) {
          splAllocRatio = '';
        }*/

        if(key === keyCol) {

          if(overrideType === 'ratio') {
            splAllocRatio = event.value;
            splAllocAmt = pshipAmt * ((splAllocRatio === '') ? 0: splAllocRatio / 100);
            updatedPartnerAmts = defaultAlloc + "," + splAllocAmt + ((splAllocRatio !== '') ? ',' + splAllocRatio : '');
          }
          else if(overrideType === 'amount') {
            splAllocAmt = event.value;
            updatedPartnerAmts = defaultAlloc + ((splAllocAmt !== '') ? "," + splAllocAmt: '');
          }

         /* if(overrideType === 'ratio') {
            updatedPartnerAmts = defaultAlloc + "," + splAllocAmt +  ',' + splAllocRatio;
          }
          else if(overrideType === 'amount') {
            updatedPartnerAmts = defaultAlloc + "," + splAllocAmt;
          }*/
          console.log('updatedPartnerAmts = ', updatedPartnerAmts);
          currRow[key] = updatedPartnerAmts;

          /*if(event.value !== null && event.value !== '') {

            if(overrideType === 'ratio') {
              splAllocRatio = event.value;
              splAllocAmt = totalAllocation * (splAllocRatio / 100);
            }
            else if(overrideType === 'amount') {
              splAllocAmt = event.value;
            }

            updatedPartnerAmts = defaultAlloc + "," + splAllocAmt +  ',' + splAllocRatio;
            console.log('updatedPartnerAmts = ', updatedPartnerAmts);
            currRow[key] = updatedPartnerAmts;
          }
          else
            splAllocAmt = splAllocAmtOrg;*/
        }
        else {
          splAllocAmt = splAllocAmtOrg;
        }

        console.log('splAllocAmt = ', splAllocAmt);


        if (splAllocAmt === undefined || splAllocAmt === '') {
          calcAmt = defaultAlloc;
        }
        /*else if(splAllocAmt === '') {
          calcAmt = '0';
        }*/
        else {
          calcAmt = splAllocAmt;
        }
        console.log('calcAmt = ', calcAmt);

        totalAllocCalc = Number(totalAllocCalc) + Number(calcAmt);
        console.log(' totalAllocCalc for key : ', key , ' = ' , totalAllocCalc);
      }
    }
    console.log(' final totalAllocCalc = ', totalAllocCalc);

    let variance = Number(pshipAmt) - totalAllocCalc;
    console.log('variance = ', variance);
    currRow.VARIANCE= variance;

  }

  saveSplAllocData() {
    console.log('Save button clicked.');



    let ptr_spl_details : any = {'ptr':'', 'def_alloc':'', 'spl_alloc': '', 'ratio': ''};
    let value :any = '';

    this.clob_settings = {};
    this.clob_data = [];

    this.rowsEdited = [];

    this.clob_settings['tax_year'] = this.taxYear;
    this.clob_settings['scenario'] = this.scenario;
    this.clob_settings['jcd_key'] = this.jcdKey;
    this.clob_settings['sso_id'] = this.ssoId;

    this.clob_settings['combination_key'] =  this.combinationKey;
    //this.clob_settings['process_name'] =  'Partnership Special Allocation Save';

    for(let i = 0; i < this.splAllocPopupData.length; i++) {
      let splAllocRecord: any = {};
      splAllocRecord = this.splAllocPopupData[i];
      console.log(' splAllocRecord = ', splAllocRecord);
      if (splAllocRecord.IS_DIRTY === 'Y') {
        this.rowsEdited.push(splAllocRecord);
        console.log('this.rowsEdited = ', this.rowsEdited);
      }
    }

    for(let i = 0; i < this.splAllocPopupData.length; i++) {
      let splAllocRecord: any = {};
      splAllocRecord = this.splAllocPopupData[i];
      console.log(' splAllocRecord = ', splAllocRecord);
      if (splAllocRecord.IS_DIRTY === 'N' && splAllocRecord.VARIANCE !== 0) {
        this.rowsEdited.push(splAllocRecord);
        console.log('this.rowsEdited = ', this.rowsEdited);
      }
    }

    if(this.rowsEdited.length > 0) {
      for(let i = 0; i < this.rowsEdited.length; i++) {
        this.clob_data.push(this.rowsEdited[i]);
      }
    }
    console.log('clob_settings = ' , this.clob_settings);
    console.log('clob_data = ' , this.clob_data);

    if(this.clob_data.length > 0) {

      if (this.validate() == true) {

        this.isSaving = true;

        console.log('valid data ... doing save server call...');

        for(let i = 0; i < this.clob_data.length; i++) {
          let singleRecord = this.clob_data[i];
          console.log('singleRecord = ', singleRecord);
          let ptr_spl_details_array : any = [];
          let ptr_spl_details_cloned : any = {'ptr':'', 'def_alloc':'', 'spl_alloc': '', 'ratio': ''};

          for(let key in singleRecord) {

            if(key.includes('/')) {
              value = singleRecord[key];
              console.log('value = ', value);
              ptr_spl_details.ptr = key;
              ptr_spl_details.def_alloc = (value.split(',')[0] === undefined) ? '': value.split(',')[0];
              ptr_spl_details.spl_alloc = (value.split(',')[1] === undefined) ? '': value.split(',')[1];
              ptr_spl_details.ratio = (value.split(',')[2] === undefined) ? '': value.split(',')[2];

              ptr_spl_details_cloned = cloneDeep(ptr_spl_details);
              ptr_spl_details_array.push(ptr_spl_details_cloned);

            }
          }
          this.clob_data[i]['ptr_amt_ratio'] = ptr_spl_details_array;
        }
        console.log('clob_data = ' , this.clob_data);

        this.subs.add(this.splAllocService.saveSplAllocationData(this.baseURL,this.taxYear,this.scenario, this.jcdKey, this.ssoId, this.processName, this.checkLockedObj, this.scenarioCode, this.isIssueKeyEnabled, this.issueKey, this.clob_settings, this.clob_data).subscribe(
          (response)=>{
            this.isLoading =false;
            this.isSaving = false;
            if(response.callSuccess == "1") {
              this.splAllocService.openSnackBar('Special Allocation Saved','gtw-snackbar--green');
              this.requestGridUpdate.emit('refresh');
            } else {
              this.splAllocService.openSnackBar('Error Saving Sourcing Data. '+response.errorMessage, 'gtw-snackbar--red');
            }
          },
          error => { this.isLoading = false; this.isSaving = false; this.splAllocService.openSnackBar('Special Allocation Save Failed. '+error.error.errorMessage, 'gtw-snackbar--red'); },
          () => { this.isLoading = false; this.isSaving = false; }
        ));
      }
      else {
        this.isSaving = false; this.splAllocService.openSnackBar('Validation Error: . '+ this.validationErrMsg, 'gtw-snackbar--yellow');
      }
    }
    else {
      this.isSaving = false;
    }
  }

  validate() {
    let isValid: boolean = true;
    //return isValid;

    let record: any = {};
    this.validationErrMsg = '';

    for(let i = 0; i < this.clob_data.length; i++) {
      record = this.clob_data[i];
      let tradingPartner;
      console.log('record = ', record);
      if(record.VARIANCE != 0) {
        isValid = false;
        if(record.TRADING_PARTNER !== '0') {
          tradingPartner = ' and Trading Partner : ' + record.TRADING_PARTNER;
        }
        else {
          tradingPartner = '';
        }
        this.validationErrMsg = 'Variance must be zero for Account : ' +  record.ACCT + ' - ' + record.ACCT_DESC + tradingPartner;
        console.log('validationErrMsg = ', this.validationErrMsg);
        break;
      }
    }
     return isValid;
  }

  modalClose() {
    this.requestGridUpdate.emit('cancel');
  }
}
